(function () {
  'use strict';

  if (window.AxiomCustomOptions) return;

  function optionRoot(node) {
    return node && node.closest ? node.closest('[data-product-custom-option]') : null;
  }

  function setError(root, message) {
    if (!root) return;
    var error = root.querySelector('[data-custom-option-error]');
    root.classList.toggle('is-invalid', Boolean(message));
    if (!error) return;
    if (message) {
      error.hidden = false;
      error.textContent = message;
    } else {
      error.hidden = true;
      error.textContent = '';
    }
  }

  function selectedChoices(root) {
    return Array.prototype.filter.call(root.querySelectorAll('[data-custom-option-choice]'), function (input) {
      return input.checked;
    }).map(function (input) {
      return input.value;
    });
  }

  function syncHiddenValue(root, value) {
    var hidden = root.querySelector('[data-custom-option-value]');
    if (hidden) hidden.value = value || '';
  }

  function strings() {
    return (window.Axiom && window.Axiom.customOptionStrings) || {};
  }

  function validateRoot(root) {
    if (!root) return '';
    var type = root.dataset.optionType;
    var required = root.dataset.optionRequired === 'true';
    var copy = strings();

    if (type === 'pills') {
      var pillValue = root.querySelector('[data-custom-option-value]');
      if (required && (!pillValue || !pillValue.value)) return copy.required || 'This field is required.';
      return '';
    }

    if (type === 'checkbox') {
      var values = selectedChoices(root);
      var min = parseInt(root.dataset.minSelections || '', 10);
      var max = parseInt(root.dataset.maxSelections || '', 10);
      if (required && !values.length) return copy.required || 'This field is required.';
      if (Number.isFinite(min) && values.length < min) return (copy.minSelections || 'Select at least [count] options.').replace('[count]', String(min));
      if (Number.isFinite(max) && values.length > max) return (copy.maxSelections || 'Select at most [count] options.').replace('[count]', String(max));
      return '';
    }

    var field = root.querySelector('input:not([type="hidden"]):not([data-custom-option-choice]), select, textarea');
    if (field && typeof field.checkValidity === 'function' && !field.checkValidity()) {
      return field.validationMessage || copy.required || 'This field is required.';
    }
    return '';
  }

  function validate(form) {
    if (!form) return { valid: true };
    var firstMessage = '';
    form.querySelectorAll('[data-product-custom-option]').forEach(function (root) {
      var message = validateRoot(root);
      setError(root, message);
      if (message && !firstMessage) firstMessage = message;
    });
    return { valid: !firstMessage, message: firstMessage };
  }

  function setSelectedLabel(root, value) {
    var selected = root.querySelector('[data-custom-option-selected]');
    if (!selected) return;
    if (value) {
      selected.hidden = false;
      selected.textContent = value;
    } else {
      selected.hidden = true;
      selected.textContent = '';
    }
  }

  function handlePillClick(event) {
    var button = event.target.closest('[data-custom-option-pill]');
    if (!button) return;
    var root = optionRoot(button);
    if (!root) return;
    root.querySelectorAll('[data-custom-option-pill]').forEach(function (pill) {
      var selected = pill === button;
      pill.classList.toggle('is-active', selected);
      pill.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    syncHiddenValue(root, button.dataset.value || '');
    setSelectedLabel(root, button.dataset.value || '');
    setError(root, '');
  }

  function handleChoiceChange(event) {
    var input = event.target.closest('[data-custom-option-choice]');
    if (!input) return;
    var root = optionRoot(input);
    if (!root) return;
    var max = parseInt(root.dataset.maxSelections || '', 10);
    var values = selectedChoices(root);
    if (Number.isFinite(max) && values.length > max) {
      input.checked = false;
      values = selectedChoices(root);
    }
    syncHiddenValue(root, values.join(', '));
    setError(root, validateRoot(root));
  }

  function fileField(root) {
    return root ? root.querySelector('[data-custom-option-file]') : null;
  }

  function formatFileSize(bytes) {
    var size = Number(bytes) || 0;
    if (size < 1024) return size + ' B';
    if (size < 1048576) return (size / 1024).toFixed(2) + ' KB';
    return (size / 1048576).toFixed(2) + ' MB';
  }

  function formatFileType(file) {
    var type = String(file && file.type || '');
    if (type.indexOf('image/') === 0) return type.replace('image/', '').toUpperCase() + ' Image';
    if (type) return type.split('/').pop().toUpperCase();
    var name = String(file && file.name || '');
    var ext = name.indexOf('.') > -1 ? name.split('.').pop() : '';
    return ext ? ext.toUpperCase() : 'File';
  }

  function revokePreview(root) {
    if (root && root._customOptionPreviewUrl) {
      URL.revokeObjectURL(root._customOptionPreviewUrl);
      root._customOptionPreviewUrl = '';
    }
  }

  function renderFilePreview(root, file) {
    if (!root) return;
    var fileWrap = root.querySelector('.product-custom-option__file');
    var dropzone = root.querySelector('[data-custom-option-dropzone]');
    var preview = root.querySelector('[data-custom-option-preview]');
    var nameEl = root.querySelector('[data-custom-option-file-name]');
    var metaEl = root.querySelector('[data-custom-option-file-meta]');
    var thumb = root.querySelector('[data-custom-option-file-thumb]');
    revokePreview(root);
    if (fileWrap) fileWrap.classList.toggle('has-file', Boolean(file));
    if (!file) {
      if (dropzone) dropzone.hidden = false;
      if (preview) preview.hidden = true;
      if (nameEl) nameEl.textContent = '';
      if (metaEl) metaEl.textContent = '';
      if (thumb) {
        thumb.hidden = true;
        thumb.removeAttribute('src');
      }
      return;
    }
    if (dropzone) dropzone.hidden = true;
    if (preview) preview.hidden = false;
    if (nameEl) nameEl.textContent = file.name;
    if (metaEl) metaEl.textContent = formatFileSize(file.size) + ', ' + formatFileType(file);
    if (thumb) {
      if (file.type && file.type.indexOf('image/') === 0) {
        root._customOptionPreviewUrl = URL.createObjectURL(file);
        thumb.src = root._customOptionPreviewUrl;
        thumb.hidden = false;
      } else {
        thumb.hidden = true;
        thumb.removeAttribute('src');
      }
    }
  }

  function clearFile(root) {
    var input = fileField(root);
    if (input) input.value = '';
    renderFilePreview(root, null);
    setError(root, '');
  }

  function assignFile(root, file) {
    var input = fileField(root);
    if (!input) return;
    var maxBytes = parseInt(input.dataset.maxBytes || '5242880', 10);
    var copy = strings();
    if (file && file.size > maxBytes) {
      clearFile(root);
      setError(root, copy.fileTooLarge || 'File is too large.');
      return;
    }
    if (file) {
      var transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
    }
    renderFilePreview(root, file || (input.files && input.files[0]) || null);
    setError(root, '');
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-custom-option-file-remove]')) {
      event.preventDefault();
      clearFile(optionRoot(event.target));
      return;
    }
    handlePillClick(event);
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-custom-option-choice]')) handleChoiceChange(event);
    if (event.target.matches('[data-custom-option-file]')) {
      var root = optionRoot(event.target);
      assignFile(root, event.target.files && event.target.files[0]);
    }
  });

  document.addEventListener('dragover', function (event) {
    var dropzone = event.target.closest('.product-custom-option__dropzone');
    if (!dropzone) return;
    event.preventDefault();
    dropzone.classList.add('is-dragging');
  });

  document.addEventListener('dragleave', function (event) {
    var dropzone = event.target.closest('.product-custom-option__dropzone');
    if (dropzone) dropzone.classList.remove('is-dragging');
  });

  document.addEventListener('drop', function (event) {
    var dropzone = event.target.closest('.product-custom-option__dropzone');
    if (!dropzone) return;
    event.preventDefault();
    dropzone.classList.remove('is-dragging');
    assignFile(optionRoot(dropzone), event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]);
  });

  window.AxiomCustomOptions = {
    validate: validate
  };
})();
